var moya = moya || {};
moya.reserve = moya.reserve || {};

jQuery.extend(moya.reserve, {
	openingHours: {
		weekdays: ['Sun', 'Mán', 'Þri', 'Mið', 'Fim', 'Fös', 'Lau'],
		addDays: function() {
			var weekdays = [];
			$('input[name="weekdays[]"]:checked', '#reserveOpeningHoursForm').each(function() {
				weekdays.push($(this).val());
			});

			var data = {
				opens: $('#opens', '#reserveOpeningHoursForm').val(),
				closes: $('#closes', '#reserveOpeningHoursForm').val(),
				weekdays: weekdays
			};

			if (data.opens && data.closes && data.weekdays) {
				var value = JSON.stringify(data);
				var element = $('<input>')
					.attr('name', 'days[]')
					.attr('type', 'hidden')
					.val(value);

				$('#reserveOpeningHoursForm').append(element);

				var weekdayStrings = [];
				weekdays.forEach(function(day) {
					if (moya.reserve.openingHours.weekdays[day]) {
						weekdayStrings.push(moya.reserve.openingHours.weekdays[day]);
					}
				});

				var line = $('<div class="well__line">');
				line.append(data.opens + ' - ' + data.closes + ' / ' + weekdayStrings.join(', '));
				line.append('<a href="#" onclick="moya.reserve.openingHours.removeDays(this)"><img src="/_moya/icons/Delete.png" alt=""/></a>');
				$('.well', '#reserveOpeningHoursForm').append(line);
			}
		},
		removeDays: function(el) {
			$(el).parent('.well__line').remove();
		}
	},

	booking: {
		init() {
			setTimeout(function() {
				var event = new MouseEvent('click', {
					view: window,
					bubbles: true,
					cancelable: true
				});
				var el = document.getElementById('reserveModal');
				if (el) {
					el.dispatchEvent(event);
				}
			}, 500);
		},
		pickTime: {
			init() {
				$('.elm_Time input:checkbox').each(function() {
					$checkbox = $(this);
					if ($checkbox.is(':checked')) {
						$checkbox.parent('label').addClass('selected');
					}

					if ($checkbox.is(':disabled')) {
						$checkbox.parent('label').addClass('disabled');
					}
				})

				$('.elm_Time input:checkbox').on('input', function() {
					$checkbox = $(this);
					$label = $checkbox.parent('label');
					if ($checkbox.is(':checked')) {
						$('.elm_Time input:checkbox')
							.prop('checked', false)
							.parent('label')
							.removeClass('selected');

						$checkbox.prop('checked', true);
						$label.addClass('selected');
					}
					else {
						$label.removeClass('selected');
					}
				})
			}
		}
	}
});
